module.exports = __webpack_public_path__ + "img/carp_1kl.9141abbb.jpg";